export const state = {
  current: null,
  currentMembers: [],
  currentInvites: [],
  pendingInvites: [],
  orgs: [],
  selectedOrg: localStorage.getItem('selectedOrgId') || null, // org id,
  apikeys: []
}
